/*
@ see https://docs.google.com/spreadsheets/d/1fp2OxKG-o_CluiUurwf0mf6LcKBeO5iLNrQTYNAYIIU/edit#gid=0
*/
const djriskjournal = {
  title: "Djriskjournal's",
  value: 'djriskjournal',
  gams: true,
  defaultGroups: ['Dynamic Insets'],
  sizes: [
    {
      id: 'djriskjournal-4col-inset',
      label: "Djriskjournal's 4U/Margin",
      width: 300,
      height: 400,
      minWidth: 0,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'djriskjournal',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'djriskjournal-8col-inset',
      label: "Djriskjournal's 8U/Margin",
      width: 620,
      height: 412,
      minWidth: 460,
      minHeight: 300,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'djriskjournal',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'djriskjournal-12col-inset',
      label: "Djriskjournal's 12U/Margin",
      width: 940,
      height: 500,
      minWidth: 621,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'djriskjournal',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
    {
      id: 'djriskjournal-16col-inset',
      label: "Djriskjournal's 16U/Margin",
      width: 1260,
      height: 500,
      minWidth: 941,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'djriskjournal',
      publish: 'inset',
      group: 'Dynamic Insets',
    },
  ],
};

export const FALLBACK_SIZE = 'djriskjournal-4col-inset';

export const STYLES =
  '\n@import url("https://asset.wsj.net/dynamic-insets/charts/wsj-digital-svg.css");';

export default djriskjournal;
